// extracted by mini-css-extract-plugin
export default {"csatItem":"CustomerRating_csatItem__KlQEw"};